import { Navigate, Outlet } from "react-router";
import { useAuth } from "../context/AuthContext";
import SideBar from "../components/SideBar";
import { IoClose, IoMenu } from "react-icons/io5";
import { useState } from "react";
import Preloader from "../components/preloader";

export default function ProtectedRoute({ allowedRoles }) {
  const { user, loading } = useAuth();
  const [openMenu, setOpenMenu] = useState(false);

  if (loading) return <Preloader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!allowedRoles.includes(user.role))
    return <Navigate to="/unauthorized" replace />;
  return (<>
    <div className="flex fixed top-0 left-0 z-50 justify-between items-center md:hidden text-black w-full h-fit p-3 bg-white">
      <div>
        <img
          src="https://www.mindcoders.in/assets/img/mindcoderlogo.webp"
          alt="mindcoders"
          className="h-14"
        />
      </div>
      <div className="" onClick={() => setOpenMenu(!openMenu)}>
        <i
          onClick={() => setOpenMenu(!openMenu)}
          className="text-2xl text-blue-950 font-bold cursor-pointer"
        >
          {openMenu ? <IoClose /> : <IoMenu />}
        </i>
      </div>
    </div>
    <div className="flex h-[100vh] pt-24 md:pt-0 w-[100%]">
      <div
        className={
          openMenu
            ? "flex h-[100vh] w-[40%] sm:w-[20%] lg:w-[16%] duration-200 flex-col justify-between border-e bg-blue-950 overflow-y-scroll"
            : "flex relative h-[100vh] w-[0%] sm:w-[20%] lg:w-[7%] duration-200 flex-col justify-between border-e bg-blue-950 overflow-x-hidden"
        }
      >
        <SideBar openMenu={openMenu} setOpenMenu={setOpenMenu} />
      </div>
      <div
        className={`${openMenu
          ? "w-[60%] sm:w-[80%] lg:w-[84%]"
          : "w-[100%] sm:w-[80%] lg:w-[93%]"
          } flex flex-col h-[100vh]`}
      >
        <Outlet />
      </div>
    </div>
  </>)
}
